import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-127" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="1ehgqyd06xk3a">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-129" data-mp="1j8p15b9ch9hi">
          LIMITED-TIME PRICE
        </p>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-130" data-mp="1n9ioa2eyqk9c">
          🏆 Special Launch Offer
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-orange bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-131" data-mp="1s82c68d4a64c">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-132" data-mp="227t545m14d2b">
            SPANISH READY
          </div>
          <div className="space-y-4 text-left" data-id="element-133" data-mp="7utoqa9tretz">
            <PriceLine label="10-Volume Curriculum" price="$197" data-id="element-134" data-mp="7vmt54lb9s8y" />
            <PriceLine label="5 Exclusive Bonuses" price="$100" data-id="element-135" data-mp="1mi98cyc9coh5" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-136" data-mp="1hpogw3gtqngs">
              <span data-id="element-137" data-mp="1crwnt64g0vb0">TOTAL VALUE:</span>
              <span className="text-brand-purple line-through" data-id="element-138" data-mp="1cosbtmkqkv9s">$297</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-139" data-mp="17pxn64038chr">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-teal" data-id="element-140" data-mp="25f0ox00f0phi">
              TODAY ONLY
            </p>
            <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-blue md:text-7xl" data-id="element-141" data-mp="20emr0asj2vx7">
              $27 <span className="text-2xl" data-id="element-142" data-mp="1rfrlz217zrvh">USD</span>
            </p>
          </div>
          <CTAButton href="https://spanish-ready.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-143" data-mp="1rhu7b8rfgwtv">
            GET THE SPANISH READY PACK
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-144" data-mp="g2p1hvw02i61">
            One-time payment · Instant download · Lifetime access
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-145" data-mp="7jc1quj1rodn">
      <span className="font-medium" data-id="element-146" data-mp="ch3vlu395kkh">{label}</span>
      <span className="font-bold text-brand-blue" data-id="element-147" data-mp="3uwxt3o7zd02k">{price}</span>
    </div>;
}